import { io } from 'socket.io-client';
import { api, tokenName } from '../config.js';

const getToken = () => localStorage.getItem(tokenName) || null;

const socket = io(api, {
  autoConnect: false,
  auth: {
    token: getToken()
  }
});

socket.on('reconnect_attempt', () => {
  socket.auth.token = getToken();
});

export const ensureSocketConnected = () => {
  if (!socket.connected && socket.disconnected) {
    socket.auth.token = getToken(); // make sure latest token is used before connect
    socket.connect();
  }
};

export const onSafe = (event, handler) => {
  const safeHandler = (...args) => {
    const result = handler(...args);
    if (result?.catch) result.catch(console.error);
  };
  socket.on(event, safeHandler);
  return () => socket.off(event, safeHandler);
};

export default socket;